
var OutcomeSetEditor = function(orgID,setID,bCanManage){
    var oThis = this;
    oThis.orgID = orgID;
    oThis.setID = setID;
    oThis.bCanManage = bCanManage || false;
    oThis.apiRoot = buildRoute(mantlroutes.org_outcome_list, { orgid: orgID, outcomesetid: setID });
    oThis.Actions = Reflux.createActions(['fetchOutcomes','createOutcome','updateOutcome','deleteOutcome']);
    oThis.containerID;
    oThis.modalsID = "outcomesetModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.OutcomeSetEditor = createReactClass({
        mixins: [Reflux.connect(oThis.OutcomeSetStore, 'outcomes')],

        componentDidUpdate: function(){
            var $manager = $(ReactDOM.findDOMNode(this));
            //$manager.find('.collapsible').collapsible();
        },

        render: function() {
            if(this.state.outcomes){

                var outcomes = [];
                for(var i = 0; i < this.state.outcomes.length; i++){
                    var oItem = this.state.outcomes[i];
                    outcomes.push(<oThis.OutcomeSetEditorItem item={oItem} key={oItem.id} edit={oThis.bCanManage} />);
                }

                return (
                    <div>
                        {/* {(function(){
                            if (oThis.bCanManage) {
                              return (<oThis.OutcomeSetEditorNew />);
                            }
                        })()} */}

                        <h3 className="h4">Outcomes</h3>
                        {(function(){
                            if (oThis.bCanManage) {
                              return (<oThis.OutcomeSetEditorNewForm />);
                            }
                        })()}

                        {(function(){
                            if (outcomes.length > 0) {
                                return (
                                    <ul className="collection collection--divided">
                                        {outcomes}
                                    </ul>
                                );
                            } else {
                                return (
                                    <div className="alert alert--information">This set doesn't have any outcomes yet.</div>
                                );

                            }
                        })()}

                    </div>
                );

            } else {
                return (
                    <div>
                        <h3 className="h4">Outcomes</h3>
                        <div className="program"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                    </div>
                );
            }

        }
    });

    //New Set
    //Set Actions
    oThis.OutcomeSetEditorNew = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        handleNew: function() {
            ReactDOM.render(<oThis.OutcomeSetEditorNewModal />, document.getElementById(oThis.modalsID));
        },

        componentDidUpdate: function() {
        },

        render: function() {
            return (
                <button className="float--right button--success button--sm" id="newSet" onClick={this.handleNew}>New Outcome</button>
            );

        }
    });


    //Outcome
    oThis.OutcomeSetEditorItem = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            var description = "No description";
            if(this.props.item.description.length > 0) {
                description = this.props.item.description
            }
            return (
                <li className="collection-item">
                    {this.props.item.url && (<div><a href={this.props.item.url} className="text--primary text--small" target="_blank" title="External Reference URL">{this.props.item.url}</a></div>)}
                    {this.props.item.code && (<code className="float--right text--small text--tightbottom" title="Framework Keycode">{this.props.item.code}</code>)}
                    <h3 className="h5"><Icon classes="icon-bullseye" /> {this.props.item.title}</h3>
                    <p>{description}</p>
                    {(function(){
                        if (oComponent.props.item.published) {
                          return (<p className="text--success"><i className="icon-check"></i> Published</p>);
                      } else {
                          return (<p className="text--warning"><i className="icon-close"></i> Not Published</p>);
                      }
                    })()}

                    {(function(){
                        if (oThis.bCanManage) {
                          return (<oThis.OutcomeSetEditorItemActions item={oComponent.props.item} />);
                        }
                    })()}
                </li>
            );

        }
    });

    //Outcome Actions
    oThis.OutcomeSetEditorItemActions = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        handleModify: function() {
            ReactDOM.render(<oThis.OutcomeSetEditorRenameModal item={this.props.item} />, document.getElementById(oThis.modalsID));
        },

        handleDelete: function() {
            var oComponent = this;
            alertify.okBtn("Delete Outcome").okStyle("border--danger").confirm("<h1 class='h4'>Are you sure you want to delete <br /><i>" + this.props.item.title + "</i>?</h1><p class='text--danger'>This can't be undone.</p>")
            .then(function (resolvedValue) {
                // "resolvedValue" is an object with the following keys: buttonClicked and event
                resolvedValue.event.preventDefault();
                if(resolvedValue.buttonClicked == "ok"){
                    //Double-check
                    alertify.okBtn("Yes, I'm Sure").confirm("<h1 class='h4 text--danger'>Are you really sure?</h1><p>Any badges linked to this outcome will lose their alignment link.</p>")
                    .then(function (resolvedValue) {
                        resolvedValue.event.preventDefault();
                        if(resolvedValue.buttonClicked == "ok"){
                            oThis.Actions.deleteOutcome(oComponent.props.item.id);
                        }
                    })
                }

            });
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            return (
                <div className="text--left">
                    <button className="button--skinny button--flat" id={"rename_" + this.props.item.id} onClick={oComponent.handleModify}>Modify</button> <button className="button--skinny text--danger button--flat" onClick={oComponent.handleDelete}>Delete</button>
                </div>
            );
        }
    });

    //Rename Modal
    //TODO: replace createClasses and use new modal component
    oThis.OutcomeSetEditorRenameModal = createReactClass({

        handleSave: function() {
            var oSet = {
                id: this.props.item.id,
                title: $("#outcomeModify").find("input[name=title]").val(),
                code: $("#outcomeModify").find("input[name=code]").val(),
                url: $("#outcomeModify").find("input[name=url]").val(),
                description: $("#outcomeModify").find("textarea[name=description]").val(),
                published: $("#outcomeModify").find("input[type=checkbox]").prop('checked')
            }
            if(oSet.title.length > 0 && oSet.description.length > 0){
                oThis.Actions.updateOutcome(oSet);
            } else {
                alertify.warning("Requires both a Title and Description")
            }
        },

        componentDidMount: function() {
            var $modal = $(ReactDOM.findDOMNode(this));
            var modalNode = ReactDOM.findDOMNode(this).parentNode;
            $modal.on("modal:close",function(){
                $modal.off("modal:close").closeModal();
                ReactDOM.unmountComponentAtNode(modalNode);
            });
            $modal.attr({
                "aria-labelledby": "rename_" + this.props.item.id,
                "role": "dialog",
                "tabindex" : "-1"
            }).openModal();
        },

        componentWillUnmount: function() {
            // console.log("component unmounted");
        },

        render: function() {
            var oComponent = this;
            return (
                <div id="outcomeModify" className="modal">
                    <div className="modal-container">
                        <div className="modal-header">
                            Modify Outcome
                            <a href="#close" className="modal-close">&times;</a>
                        </div>

                        <div className="modal-body">

                            <div className="row">
                                <div className="column-6">
                                    <p><label className="required" htmlFor={"title_" + this.props.item.id}>Title</label>
                                    <input type="text" id={"title_" + this.props.item.id} name="title" defaultValue={this.props.item.title} /></p>

                                    <div className="row">
                                        <div className="column-6">
                                            <p><label htmlFor={"code_" + this.props.item.id}>Framework Keycode</label>
                                            <input type="text" id={"code_" + this.props.item.id} name="code" defaultValue={this.props.item.code} /></p>
                                        </div>
                                        <div className="column-6">
                                            <p><label htmlFor={"url_" + this.props.item.id}>External Reference URL</label>
                                            <input type="text" id={"url_" + this.props.item.id} name="url" placeholder="http://standards.server.com/framework/123" defaultValue={this.props.item.url} /></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="column-6">
                                    <p><label className="required" htmlFor={"description_" + this.props.item.id}>Description</label>
                                    <textarea rows="5" id={"description_" + this.props.item.id} name="description" defaultValue={this.props.item.description}></textarea></p>
                                </div>
                            </div>

                            <div className="row text--loosetop">
                                <div className="column-12">
                                    <p>Published
                                        {(function(){
                                            if (oComponent.props.item.published) {
                                              return (<span><input type="checkbox" id={"published_" + oComponent.props.item.id} className="switch switch--small" aria-hidden="false" defaultChecked /><label htmlFor={"published_" + oComponent.props.item.id} className="switch-label" data-popover="tooltip" data-delay="750" title="Published">Published</label></span>);
                                          } else {
                                              return (<span><input type="checkbox" id={"published_" + oComponent.props.item.id} className="switch switch--small" aria-hidden="false" /><label htmlFor={"published_" + oComponent.props.item.id} className="switch-label" data-popover="tooltip" data-delay="750" title="Published">Published</label></span>);
                                          }
                                        })()}
                                        <br /><i>Published outcomes are available to badges for alignment.</i>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <p><button className="button--success" onClick={this.handleSave}>Save Changes</button></p>
                        </div>
                    </div>
                </div>
            );
        }
    });

    //Add Set Modal
    oThis.OutcomeSetEditorNewForm = createReactClass({

        handleSave: function() {
            var oSet = {
                title: $("#outcomeNew").find("input[name=title]").val(),
                code: $("#outcomeNew").find("input[name=code]").val(),
                url: $("#outcomeNew").find("input[name=url]").val(),
                description: $("#outcomeNew").find("textarea[name=description]").val(),
                published: $("#outcomeNew").find("input[type=checkbox]").prop('checked')
            }
            if(oSet.title.length > 0 && oSet.description.length > 0){
                //TODO: when converted to a class extension, update this quick callback to a fully wrapped function
                oThis.Actions.createOutcome(oSet, function(){
                    $("input,textarea","#outcomeNew").val("");
                });
            } else {
                alertify.warning("Requires both a Title and Description")
            }
        },

        componentDidMount: function() {
            var $form = $(ReactDOM.findDOMNode(this));
        },

        componentWillUnmount: function() {
            //console.log("component unmounted");
        },

        render: function() {
            var oComponent = this;
            return (
                <div id="outcomeNew" className="card card--rounded card--shaded">
                    <div className="card-content row">
                        <div className="column-6">
                            <p><label htmlFor="newTitle" className="required">Title</label>
                            <input type="text" id="newTitle" name="title" defaultValue="" /></p>

                            <div className="row">
                                <div className="column-6">
                                    <p><label htmlFor="newCode">Framework Keycode</label>
                                    <input type="text" id="newCode" name="code" /></p>
                                </div>
                                <div className="column-6">
                                    <p><label htmlFor="newURL">External Reference URL</label>
                                    <input type="text" id="newURL" name="url" placeholder="http://standards.server.com/framework/123" /></p>
                                </div>
                            </div>
                        </div>

                        <div className="column-6">
                            <p><label htmlFor="newDescription" className="required">Description</label>
                            <textarea rows="5" id="newDescription" name="description"></textarea></p>
                        </div>
                    </div>

                    <div className="card-footer">
                        <p className="block--inline "><button className="button--success" onClick={this.handleSave}>Add New Outcome</button></p>
                        <span className="emspace"> </span>
                        <p className="block--inline ">Published
                            <input type="checkbox" id="published" className="switch switch--small" defaultChecked aria-hidden="false" /><label htmlFor="published" className="switch-label" data-popover="tooltip" data-delay="750" title="Published">Published</label>
                            <br /><i>Published outcomes are available to badges for alignment.</i>
                        </p>
                    </div>
                </div>
            );
        }
    });

    //Add Set Modal
    oThis.OutcomeSetEditorNewModal = createReactClass({

        handleSave: function() {
            var oSet = {
                title: $("#outcomeNew").find("input[name=title]").val(),
                description: $("#outcomeNew").find("textarea[name=description]").val(),
                published: $("#outcomeNew").find("input[type=checkbox]").prop('checked')
            }
            if(oSet.title.length > 0 && oSet.description.length > 0){
                oThis.Actions.createOutcome(oSet);
            } else {
                alertify.warning("Requires both a Title and Description")
            }
        },

        componentDidMount: function() {
            var $modal = $(ReactDOM.findDOMNode(this));
            var modalNode = ReactDOM.findDOMNode(this).parentNode;
            $modal.on("modal:close",function(){
                $modal.off("modal:close").closeModal();
                ReactDOM.unmountComponentAtNode(modalNode);
            });
            $modal.attr({
                "aria-labelledby": "newSet",
                "role": "dialog",
                "tabindex" : "-1"
            }).openModal();
        },

        componentWillUnmount: function() {
            //console.log("component unmounted");
        },

        render: function() {
            var oComponent = this;
            return (
                <div id="outcomeNew" className="modal">
                    <div className="modal-container">
                        <div className="modal-header">
                            Add New Outcome
                            <a href="#close" className="modal-close">&times;</a>
                        </div>

                        <div className="modal-body">
                            <p><label htmlFor="newTitle" className="required">Title</label>
                            <input type="text" id="newTitle" name="title" defaultValue="" /></p>
                            <p><label htmlFor="newDescription" className="required">Description</label>
                            <textarea rows="4" id="newDescription" name="description"></textarea></p>
                            <p>Published
                                <input type="checkbox" id="published" className="switch switch--small" defaultChecked aria-hidden="false" /><label htmlFor="published" className="switch-label" data-popover="tooltip" data-delay="750" title="Published">Published</label>
                                <br /><i>Published outcomes are available to badges for alignment.</i>
                            </p>
                        </div>

                        <div className="modal-footer">
                            <p><button className="button--success" onClick={this.handleSave}>Save Outcome</button></p>
                        </div>
                    </div>
                </div>
            );
        }
    });



};

OutcomeSetEditor.prototype.renderList = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.OutcomeSetEditor />, document.getElementById(this.containerID));
}

//REFLUX STORE
OutcomeSetEditor.prototype.createStore = function() {
    var oThis = this;

    oThis.OutcomeSetStore = Reflux.createStore({
        listenables: oThis.Actions,
        outcomes: {}, //outcome

        init: function() {
        },

        getInitialState: function() {
            this.onFetchOutcomes();
        },

        onFetchOutcomes: function() {
            var oStore = this;
            httpGet(oThis.apiRoot).then(
                function(value) {
                    //console.table(JSON.parse(value));
                    oStore.outcomes = JSON.parse(value);
                    oStore.trigger(oStore.outcomes);
                })
            .catch(
                function(reason) {
                    console.error('Error loading outcome sets.', reason);
                    alertify.error('Unable to load outcome sets.')
                });
        },

        onCreateOutcome: function(oSet, callback) {
            var data = oSet;
            if(oSet != null && oSet.title != undefined){
                httpPost(oThis.apiRoot, data).then(
                    function(value){
                        oThis.Actions.fetchOutcomes(); //need to refetch since alpha order probably changed.
                        oThis.msgStack.AddSuccess("Outcome Created");
                        oThis.handleStack();
                        $("#outcomeNew").closeModal();
                        if(callback){
                            callback();
                        }
                    })
                .catch(
                    function(reason) {
                        oThis.msgStack.AddError("Unable to create new outcome. " + reason);
                        oThis.handleStack();
                    });
            }
        },

        onUpdateOutcome: function(oSet) {
            var data = oSet;
            if(oSet != null && oSet.id != undefined){
                httpPatch(oThis.apiRoot + '/' + oSet.id, data).then(
                    function(value){
                        oThis.Actions.fetchOutcomes(); //easiest to just redraw, set sizes will be small
                        oThis.msgStack.AddSuccess("Outcome Updated");
                        oThis.handleStack();
                        $("#outcomeModify").closeModal();
                    })
                .catch(
                    function(reason) {
                        oThis.msgStack.AddError("Unable to update outcome. " + reason);
                        oThis.handleStack();
                    });
            }
        },

        onDeleteOutcome: function(setID) {
            ///DELETE /org/orgpk/outcomeset/setpk
            httpDelete(oThis.apiRoot + '/' + setID).then(
                function(value){
                    oThis.Actions.fetchOutcomes(); //easiest to just redraw, set sizes will be small
                    oThis.msgStack.AddSuccess("Outcome Deleted");
                    oThis.handleStack();
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error deleting outcome.', reason);
                    oThis.msgStack.AddError("Unable to delete Outcome.");
                    oThis.handleStack();
                });
        }


    });
}
